import React from 'react'

const Item = ({code, name, stocks, category, subCategory}) => {
  return (
    <React.Fragment>
        <span>{code}</span>
        <span>{name}</span>
        <span>{stocks}</span>
        <span>{category}</span>
        <span>{subCategory}</span>
    </React.Fragment>
  )
}

export default Item